import warn from 'warning';
export * from './easing';
export * from './vnode';
export * from './utils';
export * from './dom';
export { default as browser } from './browser';
export { default as CollapseTransition } from './transition/collapseTransition';
export * from './ssr';
export * from './tree/index';
var warned = {};
export function warning() {
  var valid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!valid && !warned[message]) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    warn.apply(void 0, [false, message].concat(args));
    warned[message] = true;
  }
}
export { default as emitter } from './mixins/emitter';